import React, { Component } from 'react';
import { connect } from 'react-redux';
import pick from 'lodash/pick';
import { Link } from 'react-router';
import { show } from 'redux-modal';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Button from 'react-bootstrap-button-loader';
import Confirm from 'react-confirm-bootstrap';
import moment from 'moment';
import { Ssp as Layout } from '../../../components/layouts';
import { Spinner } from '../../../components/common';
import { SspApi } from '../../../api';
import { humanize } from '../../../utils/helpers/text_formatters';
import FormModal from './Form';
import Popup from './Popup';
import { ButtonAdd } from '../../../components/common/buttons';

class Index extends Component {

  newResource() {
    const { dispatch } = this.props;
    dispatch(show('WebsiteFormModal', {
      heading: 'New Website',
      formAction: 'Create'
    }));
  }

  handleEdit(c, r) {
    const { dispatch } = this.props;

    dispatch(show('WebsiteFormModal', {
      website: r,
      heading: `Editing Website - ${r.name}`,
      formAction: 'Update'
    }));
  }

  handleDelete(c) {
    const { dispatch } = this.props;
    dispatch(SspApi.actions.websiteDelete.post(c, (error, success) => {
      if (success) dispatch(SspApi.actions.websites());
    }));
  }

  renderActions(c, r) {
    return (
      <ul className='list-inline'>
        <li>
          <Button
            bsSize='xsmall'
            bsStyle='success'
            onClick={this.handleEdit.bind(this, c, r)}
          >
            Edit
          </Button>
        </li>

        <li>
          <Link to={`/ssp/websites/${r.slug}/dashboard`} className='btn-info btn btn-xs'>
            Dashboard
          </Link>
        </li>

        <li>
          <Confirm
            onConfirm={this.handleDelete.bind(this, c)}
            body='Are you sure you want to delete this?'
            confirmText='Confirm Delete'
            title={`Deleting Website - ${r.name}`}
          >
            <button className='btn-danger btn btn-xs'>
              Delete
            </button>
          </Confirm>
        </li>
      </ul>
    );
  }

  render() {
    const { websites, isLoading } = this.props;
    const { data } = websites || {};

    return (
      <Layout {...pick(this.props, ['routeParams', 'location', 'routes'])}>
        <div className='ibox'>
          <div className='ibox-title'>
            <h5>Websites</h5>
          </div>
          <div className={`p-b-lg ibox-content${isLoading ? ' sk-loading' : ''}`}>
            <Spinner />

            <div className='m-b-sm text-left'>
              <ButtonAdd
                btnLabel='Add Website'
                onClick={this.newResource.bind(this)}
              />
            </div>

            <BootstrapTable
              striped
              ref='WebsitesTable'
              data={data || []}
            >
              <TableHeaderColumn
                width="200"
                dataField="name"
                dataFormat={(c, r) => {
                  return (
                    <Link to={`/ssp/websites/${r.slug}/dashboard`}>
                      {c}
                    </Link>
                  );
                }}
              >
                Name
              </TableHeaderColumn>

              <TableHeaderColumn
                width="200"
                dataField="url"
                dataFormat={(c) => c}
              >
                URL
              </TableHeaderColumn>

              <TableHeaderColumn
                width="100"
                dataField="status"
                dataFormat={(c) => humanize(c)}
              >
                Status
              </TableHeaderColumn>

              <TableHeaderColumn
                width="100"
                dataField="pixel_status"
                dataFormat={(c) => humanize(c)}
              >
                Pixel Status
              </TableHeaderColumn>

              <TableHeaderColumn
                width="150"
                dataField="created_at"
                dataFormat={(c) => moment(c).local().format('MMMM Do[,] YYYY')}
              >
                Date
              </TableHeaderColumn>

              <TableHeaderColumn
                isKey
                width="250"
                dataField="uuid"
                dataFormat={this.renderActions.bind(this)}
              >
                Actions
              </TableHeaderColumn>

            </BootstrapTable>
          </div>
        </div>
        <FormModal />
        <Popup />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  const { ssp } = state;
  return { websites: ssp.websites.data, isLoading: ssp.websites.loading };
};

export default connect(mapStateToProps)(Index);
